import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const SidebarContainer = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 200px;
    height: 100vh;
    background-color: rgb(4, 23, 44);
    color: white;
    z-index: 1000;
    text-align: center;
    transform: ${props => props.isOpen ? 'translateX(0)' : 'translateX(-100%)'};
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    
    @media (max-width: 700px) {
        width: 150px;
        z-index: 1001;
    }
`;

const Logo = styled.div`
    padding: 20px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid rgb(103, 111, 119);
    
    @media (max-width: 700px) {
        padding: 15px;
        font-size: 18px;
    }
`;

const MenuList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    flex: 1;
`;

const MenuItem = styled.li`
    margin: 0;
    font-size: 15px;
`;

const MenuLink = styled(Link)`
    display: block;
    padding: 15px 20px;
    color: white;
    text-decoration: none;
    transition: background-color 0.3s;
    background-color: ${props => props.active ? '#34495e' : 'transparent'};
    font-size: 16px;
    
    &:hover {
        background-color: #34495e;
    }
    
    @media (max-width: 700px) {
        padding: 12px 20px;
        font-size: 15px;
    }
`;

const CloseButton = styled.button`
    position: absolute;
    top: 7px;
    right: 7px;
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
    display: none;
    
    @media (max-width: 700px) {
        display: none
    }
    
    &:hover {
        opacity: 0.7;
    }
`;

const ContactLink = styled.a`
    display: block;
    padding: 15px 20px;
    color: white;
    text-decoration: none;
    transition: background-color 0.3s;
    border-top: 1px solid rgb(103, 111, 119);
    font-size: 14px;
    
    &:hover {
        background-color: #34495e;
    }
    
    @media (max-width: 700px) {
        padding: 12px 20px;
        font-size: 13px;
    }
`;

const Sidebar = ({ isOpen, onClose }) => {
    const location = useLocation();
    
    const menuItems = [
        { path: '/', label: '대시보드' },
        { path: '/products', label: '제품 관리' },
        { path: '/brands', label: '브랜드 관리' },
        // { path: '/categories', label: '카테고리 관리' },
        // { path: '/settings', label: 'Settings' }
    ];

    return (
        <SidebarContainer isOpen={isOpen}>
            <CloseButton onClick={onClose}>×</CloseButton>
            <Logo>CST Admin</Logo>
            <MenuList>
                {menuItems.map(item => (
                    <MenuItem key={item.path}>
                        <MenuLink 
                            to={item.path}
                            active={location.pathname === item.path ? 1 : 0}
                            onClick={onClose}
                        >
                            {item.icon} {item.label}
                        </MenuLink>
                    </MenuItem>
                ))}
            </MenuList>
            <ContactLink 
                href="https://www.notion.so/2a2e40bddf9c8098a693cf3e3f62d673?v=2a2e40bddf9c80d08db6000ca31e414f&source=copy_link"
                target="_blank"
                rel="noopener noreferrer"
            >
                개발자한테 문의하기
            </ContactLink>
        </SidebarContainer>
    );
};

export default Sidebar;